import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GoBackButtonWithTitle, PageHeaderBoldTitle } from 'components';
import { EmployeesTable } from 'features/employees/components';
import { Links } from 'settings';

import { PageW } from './styled';

export const OffboardingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onNavigateBack = () => {
    navigate(Links.actions.index);
  };
  return (
    <PageW>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle
        title={t('offboarding.title')}
        onClickCloseIcon={onNavigateBack}
        buttonPosition="static"
      />
      <EmployeesTable isOffboarding={true} />
    </PageW>
  );
};
